<template>
  <div v-if="page" class="min-h-screen bg-soft-white">
    <article class="container mx-auto px-6 py-12 max-w-3xl">
      <nav class="text-sm text-dark-gray/60 mb-4" aria-label="Breadcrumb">
        <RouterLink to="/" class="hover:text-light-purple">Home</RouterLink>
        <span class="mx-1">/</span>
        <RouterLink to="/how-it-works" class="hover:text-light-purple">How it works</RouterLink>
        <span class="mx-1">/</span>
        <span class="text-dark-gray">{{ page.h1 }}</span>
      </nav>
      <h1 class="text-4xl font-poppins font-bold text-dark-gray mt-4 mb-6">{{ page.h1 }}</h1>
      <ol class="card-neumorphic !p-6 mb-8 space-y-3">
        <li v-for="(s, i) in page.steps" :key="s" class="flex gap-3 text-dark-gray/80">
          <span class="font-bold text-light-purple">{{ i + 1 }}.</span> {{ s }}
        </li>
      </ol>
      <section v-for="sec in page.sections" :key="sec.heading" class="mb-8">
        <h2 class="text-2xl font-semibold text-dark-gray mb-3">{{ sec.heading }}</h2>
        <p v-for="(para, i) in sec.paragraphs" :key="i" class="text-dark-gray/75 leading-relaxed mb-3">
          {{ para }}
        </p>
      </section>
      <section v-if="page.faqs?.length" class="card-neumorphic !p-6 mb-8">
        <h2 class="text-xl font-semibold mb-4">FAQs</h2>
        <div v-for="f in page.faqs" :key="f.q" class="mb-3">
          <h3 class="font-semibold">{{ f.q }}</h3>
          <p class="text-sm text-dark-gray/70">{{ f.a }}</p>
        </div>
      </section>
      <div class="flex flex-wrap gap-2">
        <RouterLink
          v-for="href in page.related"
          :key="href"
          :to="href"
          class="text-sm text-light-purple underline"
        >{{ href }}</RouterLink>
      </div>
    </article>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getHowItWorksPage } from '../config/howItWorks'
import {
  breadcrumbSchema,
  faqSchema,
  graphSchema,
  organizationSchema,
  useSeo,
} from '../composables/useSeo'

export default {
  name: 'HowItWorksPage',
  setup() {
    const route = useRoute()
    const page = computed(() => getHowItWorksPage(route.params.slug))
    useSeo(
      computed(() => {
        const p = page.value
        if (!p) return { title: 'Not found', robots: 'noindex', path: '/how-it-works' }
        const path = `/how-it-works/${p.slug}`
        return {
          title: p.title,
          description: p.description,
          path,
          keywords: [p.h1, 'Homvisit Kerala'],
          schema: graphSchema([
            organizationSchema(),
            breadcrumbSchema([
              { name: 'Home', path: '/' },
              { name: 'How it works', path: '/how-it-works' },
              { name: p.h1, path },
            ]),
            faqSchema(p.faqs),
          ]),
        }
      })
    )
    return { page }
  },
}
</script>
